function paginate( array, pageSize, pageNumber ) {
    --pageNumber; // because pages logically start with 1, but technically with 0
    return { data: array.slice( pageNumber * pageSize, ( pageNumber + 1 ) * pageSize ), total: array.length };
}

export default {
    paginate
};
